var dragable = document.querySelector('#portfolio-section-container');
var speed = 2;
var isPointerDown = false;
var startX;
var scrollLeft;

dragable.addEventListener('pointerdown', (event) => {
  isPointerDown = true;

  dragable.classList.add('active');

  startX = event.pageX - dragable.offsetLeft;
  scrollLeft = dragable.scrollLeft;
});

dragable.addEventListener('pointerleave', (event) => {
  isPointerDown = false;
  dragable.classList.remove('active');
});

dragable.addEventListener('pointerup', (event) => {
  isPointerDown = false;
  dragable.classList.remove('active');
});

dragable.addEventListener('pointermove', (event) => {
  if (!isPointerDown) return;

  event.preventDefault();

  const x = event.pageX - dragable.offsetLeft;
  const move = (x - startX) * speed;
  dragable.scrollLeft = scrollLeft - move;
});